import { format } from "date-fns";

function formatIsoDate(dateString) {
  const formattedDate = format(new Date(dateString), "dd/MM/yyyy");
  return formattedDate;
}

function formatYearDate(dateString) {
  const formattedDate = format(new Date(dateString), "yyyy-MM-dd");
  return formattedDate;
}

function formatDate(date) {
  if (date) {
    // Adiciona "T00:00:00" se não houver tempo na string
    const dateTime = date.includes(" ") ? date : date + "T00:00:00";
    // Remove milissegundos e "Z" se existirem
    const cleanedDate = dateTime.split(".")[0].replace("Z", "");
    const localDate = new Date(cleanedDate);

    // Verifica se a data é válida
    if (isNaN(localDate.getTime())) {
      return date; // Retorna o valor original se a data for inválida
    }

    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDate = localDate.toLocaleDateString("pt-BR", options);
    return formattedDate;
  } else {
    return date; // Mantém vazio se o campo estiver vazio
  }
}

export { formatIsoDate, formatDate, formatYearDate };
